module.exports = __webpack_public_path__ + "static/img/brees-2011-top-image-thumb.a2d1b5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2011-top-image-thumb.jpg
// module id = GYas
// module chunks = 1